import { render, staticRenderFns } from "./ASAClassification.vue?vue&type=template&id=551cc739&scoped=true"
import script from "./ASAClassification.vue?vue&type=script&lang=js"
export * from "./ASAClassification.vue?vue&type=script&lang=js"
import style0 from "./ASAClassification.vue?vue&type=style&index=0&id=551cc739&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551cc739",
  null
  
)

export default component.exports